import { call, put } from "redux-saga/effects";
import * as api from "../../../Service/api";
import ReportConfigurationActions from "./report-configuration.reducer";
import {
  hasReportConfigurationXlsxPayload,
  normalizeReportConfigurations,
  parseReportGenerateError,
  resolveReportDownloadFilename,
  triggerReportConfigurationXlsxDownload,
} from "../../../constants/reportConfiguration";

export function* reportConfigurationsRequest(action) {
  const { businessId } = action;
  const response = yield call(api.getReportConfigurations, businessId);
  if (response.ok) {
    yield put(
      ReportConfigurationActions.reportConfigurationsSuccess(
        normalizeReportConfigurations(response.data)
      )
    );
  } else {
    yield put(ReportConfigurationActions.reportConfigurationsFailure(response.data));
  }
}

export function* createReportConfiguration(action) {
  const { businessId, reportConfiguration } = action;
  const response = yield call(api.createReportConfiguration, reportConfiguration);
  if (response.ok) {
    yield put(ReportConfigurationActions.createReportConfigurationSuccess(response.data));
    yield put(ReportConfigurationActions.reportConfigurationsRequest(businessId));
  } else {
    yield put(ReportConfigurationActions.createReportConfigurationFailure(response.data));
  }
}

export function* generateReportConfiguration(action) {
  const { configId, configName } = action;
  try {
    const response = yield call(api.generateReportConfigurationXlsx, configId);
    if (response.ok && hasReportConfigurationXlsxPayload(response.data)) {
      triggerReportConfigurationXlsxDownload(response.data, {
        filename: resolveReportDownloadFilename(response.headers),
        configName,
        configId,
      });
      yield put(ReportConfigurationActions.generateReportConfigurationSuccess());
    } else {
      const message = parseReportGenerateError(response) || "GENERATE_FAILED";
      yield put(ReportConfigurationActions.generateReportConfigurationFailure(message));
    }
  } catch {
    yield put(ReportConfigurationActions.generateReportConfigurationFailure("GENERATE_FAILED"));
  }
}

export function* deleteReportConfiguration(action) {
  const { configId, businessId } = action;
  const response = yield call(api.deleteReportConfiguration, configId);
  if (response.ok) {
    yield put(ReportConfigurationActions.deleteReportConfigurationSuccess());
    yield put(ReportConfigurationActions.reportConfigurationsRequest(businessId));
  } else {
    yield put(ReportConfigurationActions.deleteReportConfigurationFailure(response.data));
  }
}
